export const GET_ALL_KEY_HOLDERS = 'afterDeath/GET_ALL_KEY_HOLDERS';
export const ADD_KEY_HOLDER = 'afterDeath/ADD_KEY_HOLDER';
export const DELETE_KEY_HOLDER = 'afterDeath/DELETE_KEY_HOLDER';
